import { usePurchaseOptionsLoaderData } from "./purchaseOptionsLoader";
import TitleCard from "./TitleCard";
import styles from "./PurchaseOptions.module.scss";
import NoResults from "common/graphics/NoResults";
import { FormattedMessage, useIntl } from "react-intl";
import OfferItem from "./OfferItem";
import DefaultTemplate from "routes/home/layout/content-templates/default/DefaultTemplate";
import CompareAndPurchaseCartButton from "../index/common/CompareAndPurchaseCartButton.tsx";

export default function PurchaseOptions() {
  const { courseMaterial, groupedOffers, settings, cart } =
    usePurchaseOptionsLoaderData();
  const {
    epos,
    preferredRetailers,
    retailers,
    publisher,
    edition,
    copyrightYear,
  } = groupedOffers;
  const intl = useIntl();
  const hasBookStoreOffers = !!epos.length;
  const hasPreferredRetailerOffers = !!preferredRetailers.length;
  const hasRetailerOffers = !!retailers.length;
  const hasResults =
    hasBookStoreOffers || hasPreferredRetailerOffers || hasRetailerOffers;

  return (
    <DefaultTemplate
      title={intl.formatMessage({ defaultMessage: "Purchase Options" })}
      headerConfig={{
        backFallbackLocation: "/my-courses",
        bonusButtons: <CompareAndPurchaseCartButton cart={cart} />,
        theme: "white",
      }}
    >
      <TitleCard
        vbid={courseMaterial.vbid}
        title={courseMaterial.title}
        requiredCode={courseMaterial.requiredCode}
        author={courseMaterial.author}
        publisher={publisher}
        edition={edition}
        copyrightYear={copyrightYear}
      />
      <div className={styles.resultsContainer}>
        {hasResults && (
          <>
            {hasBookStoreOffers && (
              <div>
                <h2 className={styles.sectionHeader}>
                  {settings.shortStoreName}
                </h2>
                <ul className={styles.sectionContent}>
                  {epos.map((offer, index) => (
                    <OfferItem key={index} offer={offer} />
                  ))}
                </ul>
              </div>
            )}
            {hasPreferredRetailerOffers && (
              <div>
                <h2 className={styles.sectionHeader}>
                  {settings.preferredPartnerText}
                </h2>
                <ul className={styles.sectionContent}>
                  {preferredRetailers.map((offer, index) => (
                    <OfferItem key={index} offer={offer} />
                  ))}
                </ul>
              </div>
            )}
            {hasRetailerOffers && (
              <div>
                <h2 className={styles.sectionHeader}>
                  <FormattedMessage defaultMessage={"From the Web"} />
                </h2>
                <ul className={styles.sectionContent}>
                  {retailers.map((offer, index) => (
                    <OfferItem
                      key={index}
                      offer={offer}
                      isPrimaryAction={false}
                    />
                  ))}
                </ul>
              </div>
            )}
          </>
        )}

        {!hasResults && (
          <div className={styles.noResultsContainer}>
            <NoResults />
            <div className={styles.noResultsText}>
              <FormattedMessage
                defaultMessage={"No purchase options were found"}
              />
            </div>
            <div className={styles.noResultsExplanation}>
              <FormattedMessage
                defaultMessage={
                  "If you want to purchase this item, please contact your bookstore."
                }
              />
            </div>
          </div>
        )}
      </div>
    </DefaultTemplate>
  );
}
